(function ($) {
    $("document").ready(setup);

    function setup() {
        tabsProducts();
        //moreLoadRealizations();
        filterViewAdvice();
        tabsSheetProduct();

        $(".see-more").click(seeMore);
    }

    // Fonction d'onglet détails de produit
    function tabsSheetProduct() {
        $(".product-tabs .slider-tab-footer li").on("click", function (e) {
            e.preventDefault();
            var tabID = $(this).attr("data-slide");

            $(".blockslidsproduct-section-1").removeClass("open");
            $(".blockslidsproduct-section-2").removeClass("open");
            $(".blockslidsproduct-section-3").removeClass("open");
            $(".blockslidsproduct-section-4").removeClass("open");
            $(".blockslidsproduct-section-5").removeClass("open");
            $(".blockslidsproduct-section-6").removeClass("open");
            $(".blockslidsproduct-section-" + tabID).addClass("open");

            $(".tab-slider-footer-1").removeClass("active");
            $(".tab-slider-footer-2").removeClass("active");
            $(".tab-slider-footer-3").removeClass("active");
            $(".tab-slider-footer-4").removeClass("active");
            $(".tab-slider-footer-5").removeClass("active");
            $(".tab-slider-footer-6").removeClass("active");
            $(".tab-slider-footer-" + tabID).addClass("active");

            if (window.matchMedia("(max-width:1000px)").matches) {
                $(".tab-slider-footer-" + tabID).each(function () {
                    var libelle = $(".tab-slider-footer-" + tabID + " span").text();
                    $(".libelle-tab").html(libelle);
                });
                $(".ul-slider-tab-footer").hide();
            }

            $("#section-1").removeAttr("open");
            $("#section-2").removeAttr("open");
            $("#section-3").removeAttr("open");
            $("#section-4").removeAttr("open");
            $("#section-5").removeAttr("open");
            $("#section-6").removeAttr("open");
            $("#section-" + tabID).attr("open", "open");

            $(".blockslidsproduct-section-" + tabID + " .load").addClass(
                "loader-slide"
            );
            var delayTime = 1500;
            setTimeout(function () {
                $(".blockslidsproduct-section-" + tabID + " .load").removeClass(
                    "loader-slide"
                );
            }, delayTime);
        });
        $(".mobile-slider-tab-footer").click(function (e) {
            e.preventDefault();
            $(".ul-slider-tab-footer").toggle();
        });
    }

    // Filtre de la vue des conseils sous mobile
    function filterViewAdvice() {
      var lang = drupalSettings.path.currentLanguage;

      if (window.matchMedia("(max-width:760px)").matches) {
          if(lang === 'es'){
            $("<span class='filters-list-categorie-advice'><span class='filter'>Filtros :</span><svg class='icon-arrow'><use xlink:href='../themes/custom/akena/images/sprites.svg#icone-fleche-droite'></use></svg></span>").insertAfter(".views-advice header");
          } else if(lang === 'it'){
            $("<span class='filters-list-categorie-advice'><span class='filter'>Filtri :</span><svg class='icon-arrow'><use xlink:href='../themes/custom/akena/images/sprites.svg#icone-fleche-droite'></use></svg></span>").insertAfter(".views-advice header");
          } else if(lang === 'en'){
            $("<span class='filters-list-categorie-advice'><span class='filter'>Filters :</span><svg class='icon-arrow'><use xlink:href='../themes/custom/akena/images/sprites.svg#icone-fleche-droite'></use></svg></span>").insertAfter(".views-advice header");
          } else{
            $("<span class='filters-list-categorie-advice'><span class='filter'>Filtres :</span><svg class='icon-arrow'><use xlink:href='../themes/custom/akena/images/sprites.svg#icone-fleche-droite'></use></svg></span>").insertAfter(".views-advice header");
          }
            $(".links-list").hide();
        }
        $(".filters-list-categorie-advice").on("click", function (e) {
            e.preventDefault();
            $(".links-list").toggle();
        });
    }

    // Fonction plus de réalisations par device
    function moreLoadRealizations() {
        if (window.matchMedia("(max-width:767px)").matches) {
            $(".blockrealization")
                .slice(0, 1)
                .show();
        } else if (window.matchMedia("(max-width:1024px)").matches) {
            $(".blockrealization")
                .slice(0, 2)
                .show();
        } else {
            $(".blockrealization")
                .slice(0, 4)
                .show();
        }
        if ($(".blockrealization:hidden").length == 0) {
            $("#load-more").hide();
        }
        $("#load-more").on("click", function (e) {
            e.preventDefault();
            if (window.matchMedia("(max-width:767px)").matches) {
                $(".blockrealization:hidden")
                    .slice(0, 1)
                    .show();
            } else if (window.matchMedia("(max-width:1024px)").matches) {
                $(".blockrealization:hidden")
                    .slice(0, 2)
                    .show();
            } else {
                $(".blockrealization:hidden")
                    .slice(0, 4)
                    .show();
            }
            if ($(".blockrealization:hidden").length == 0) {
                $("#load-more").hide();
            } else {
                $("html,body").animate(
                    {
                        scrollTop: parseInt($(this).offset().top) - 800
                    },
                    700
                );
            }
        });
    }

    // Fonction pour scrool pour en voir plus
    function seeMore(e) {
        e.preventDefault();
        $("body, html").animate(
            {
                scrollTop: $("section")
                    .first()
                    .next("section")
                    .offset().top - 300
            },
            2000
        );
    }

    // Fonction d'onglet de produit
    function tabsProducts() {
        $('#blockproductdetailtabs-level ul.tabs li').click(function() {
            var tabsID = $(this).attr('data-id-tabs');
            var tabID = $(this).attr('data-tab');

            $("#blockproductdetailtabs-level .tabs-" + tabsID + " .tab-link").each(function() {
                $("#blockproductdetailtabs-level .tabs-" + tabsID + " .tab-link").removeClass('current');
            });

            $("#blockproductdetailtabs-level .tabs-" + tabsID + " ." + tabID).addClass('current');

            $("#blockproductdetailtabs-level .tabs-" + tabsID + " .tab-content").each(function() {
                $("#blockproductdetailtabs-level .tabs-" + tabsID + " .tab-content").removeClass('current');
            });

            $("#blockproductdetailtabs-level .tabs-" + tabsID + " #" + tabID).addClass('current');
        });
    }

})(jQuery);
